import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import GoogleLoginButton from '@/components/sns-login-button/GoogleLoginButton.vue'
import LineLoginButton from '@/components/sns-login-button/LineLoginButton.vue'
import FacebookLoginButton from '@/components/sns-login-button/FacebookLoginButton.vue'
import { PropType } from 'vue'
import { SNS_METHOD, SNS_SITE } from '@/constants/common'
import { openSnsConnectUrl } from '@/utils'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useLogin } from '@/use/loginHelper'


export default /*#__PURE__*/_defineComponent({
  props: {
  googleTheme: {
    type: String as PropType<'light' | 'neutral'>,
    default: 'light',
  },
  arrangement: {
    type: String as PropType<'vertical' | 'horizontal'>,
    default: 'vertical',
  },
  snsMethod: {
    type: String as PropType<SNS_METHOD>,
    default: SNS_METHOD.LOGIN,
  },
},
  setup(__props) {

const props = __props

const { snsSetCookieRedirect } = useLogin({}, {})

const route = useRoute()
const store = useStore()



const handleSnsButtonClick = (sns: SNS_SITE) => () => {
  if (props.snsMethod === SNS_METHOD.LOGIN) snsSetCookieRedirect()
  const payload = {}
  if (props.snsMethod === SNS_METHOD.INVITE) {
    payload['inviteCode'] = route.params.key
  }
  openSnsConnectUrl(sns, props.snsMethod, payload)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "sns-login-button-group",
    class: _normalizeClass(__props.arrangement === 'vertical' ? 'd-flex flex-column gap-2' : 'row')
  }, [
    _createVNode(LineLoginButton, {
      class: "login-button-container",
      arrangement: __props.arrangement,
      "sns-method": __props.snsMethod,
      "on-button-click": handleSnsButtonClick(_unref(SNS_SITE).SNS_LINE)
    }, null, 8, ["arrangement", "sns-method", "on-button-click"]),
    _createVNode(GoogleLoginButton, {
      theme: __props.googleTheme,
      class: "login-button-container",
      arrangement: __props.arrangement,
      "sns-method": __props.snsMethod,
      "on-button-click": handleSnsButtonClick(_unref(SNS_SITE).SNS_GOOGLE)
    }, null, 8, ["theme", "arrangement", "sns-method", "on-button-click"]),
    false
      ? (_openBlock(), _createBlock(FacebookLoginButton, {
          key: 0,
          class: "login-button-container",
          arrangement: __props.arrangement,
          "sns-method": __props.snsMethod,
          "on-button-click": handleSnsButtonClick(_unref(SNS_SITE).SNS_FACEBOOK)
        }, null, 8, ["arrangement", "sns-method", "on-button-click"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})